if (!customElements.get('form-validation')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.formInputPhone = this.form.querySelector('input[type="tel"]');
      this.errorMessage = this.querySelector('.field__message--error.tel');

      this.formInputPhone.addEventListener('input', this.validatePhoneField.bind(this));
    }

    validatePhoneField() {
      const phoneValue = this.formInputPhone.value;
      const phonePattern = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]{8,14}$/g;
      const phoneIsValid = phonePattern.test(phoneValue);

      if (phoneValue === '') {
        this.clearValidation();
      } else {
        this.toggleValidationState(phoneIsValid);
      }

      // Trigger validation UI
      this.formInputPhone.reportValidity();
    }

    clearValidation() {
      this.formInputPhone.setCustomValidity('');
      this.errorMessage.classList.remove('block');
    }

    toggleValidationState(isValid) {
      if (isValid) {
        this.clearValidation();
      } else {
        this.formInputPhone.setCustomValidity(' ');
        this.errorMessage.classList.add('block');
      }
    }
  }
  window.FormValidation = FormValidation;
  customElements.define('form-validation', FormValidation);
}
